.orderingButton {
  cursor: pointer;
}

.orderingButtonIcon {
  display: inline;
  width: 16px;
  margin-left: 10px;
}
